<template>
  <div>
    <el-dialog :visible.sync="showDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               width="40%"
               top="5vh"
               :show-close="false"
               :title="$t('model.AddTask')">
      <div class="form-box">
        <el-form style="height:90%"
                 label-position="left"
                 label-width="120px"
                 size="medium"
                 :model="form"
                 ref="formTask">
          <myScroll style="width:100%;height:100%">
            <div style="margin:0 auto;width:95%">
              <div v-if="type!==3">
                <template class="single-task"
                          v-if="addTaskPointList.length<=1 || !forAll">
                  <template class="moisture"
                            v-if="type === 2">
                    <el-form-item :label="$t('model.MaxRh')"
                                  label-width="20%">
                      <el-slider show-input
                                 :max="99"
                                 :min="75"
                                 v-model="form.MaxRh">
                      </el-slider>
                    </el-form-item>
                    <el-form-item :label="$t('model.HoleDepth')">
                      <el-input size="small"
                                v-model="form.DepthFromTopOfSlab"
                                :placeholder="$t('model.HoleDepth')"></el-input>
                    </el-form-item>
                  </template>
                  <el-form-item :label="$t('model.Name')">
                    <el-input size="small"
                              v-model="Name"
                              :placeholder="$t('model.Name')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('model.Type')">
                    <el-select size="small"
                               :disabled="true"
                               v-model="type">
                      <el-option v-for=" i of taskType"
                                 :key="i.Key"
                                 :label="$t('task.'+i.Value)"
                                 :value="i.Key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.Status')">
                    <el-select size="small"
                               v-model="form.Status">
                      <el-option v-for=" i of taskStatus"
                                 :key="i.Value"
                                 :label="$t('api.'+i.Key)"
                                 :value="i.Value"></el-option>
                    </el-select>
                  </el-form-item>
                  <template v-if="type === 1&&subtype===1">
                    <el-form-item :label="$t('model.Product')"
                                  prop="nonM2ProductId"
                                  class="is-required"
                                  key="1"
                                  :rules="rules.nonM2ProductId">
                      <el-select v-model="form.nonM2ProductId"
                                 style="width:85%"
                                 size="small"
                                 filterable
                                 remote
                                 @change="nonM2ProductIdChange"
                                 @visible-change="showNonM2ProductSelect"
                                 :remote-method="remoteMethod">
                        <el-option v-for="i of nonM2ProductList"
                                   :key="i.ProductId"
                                   :label="i.SKU"
                                   :value="i.ProductId">
                          <span style="float: left">{{ i.SKU }}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">
                            {{i.Quantity}} {{$config.getNonM2ProductUnit(i.Unit)}}</span>
                        </el-option>
                      </el-select>
                      <el-button circle
                                 type="primary"
                                 size="small"
                                 :title="$t('productDialog.AddProduct')"
                                 style="position: absolute;top:50%;transform: translateY(-50%);right:0"
                                 @click="openNonM2ProductDialog"><i class="el-icon-plus"></i></el-button>
                    </el-form-item>

                    <el-form-item :label="$t('model.TaskTotalQty')"
                                  prop="taskTotalQty"
                                  class="is-required"
                                  key="2"
                                  :rules="rules.taskTotalQty"
                                  v-show="form.nonM2ProductId&&form.nonM2ProductId.length>0">
                      <el-input size="small"
                                v-model="form.taskTotalQty"
                                min="0"
                                id="taskTotalQtyInput"
                                @input="onInput">
                        <template slot="append">
                          <span>
                            {{$t('model.RetainageQty')}}: {{nonM2Product.RetainageQty}} {{$config.getNonM2ProductUnit(nonM2Product.Unit)}}
                          </span>
                          <span style="margin-left:8px">
                            {{$t('model.JobsiteTotalQty')}}: {{nonM2Product.Quantity}} {{$config.getNonM2ProductUnit(nonM2Product.Unit)}}
                          </span>
                        </template>
                      </el-input>
                    </el-form-item>

                  </template>
                  <el-form-item :label="$t('model.TaskGroup')">
                    <el-select size="small"
                               style="width:85%"
                               clearable
                               v-model="form.TaskPhaseId">
                      <el-option v-for="i of taskGroup"
                                 :key="i.PhaseId"
                                 :label="i.Name"
                                 :value="i.PhaseId"></el-option>
                    </el-select>
                    <el-button circle
                               type="primary"
                               size="small"
                               v-has="'Create Task Group'"
                               :title="$t('groupDialog.AddTaskGroup')"
                               style="position: absolute;top:50%;transform: translateY(-50%);right:0"
                               @click="openGroupDialog"><i class="el-icon-plus"></i></el-button>
                  </el-form-item>
                  <el-form-item :label="$t('model.StartDate')">
                    <el-date-picker v-model="form.StartDate"
                                    size="small"
                                    :placeholder="$t('model.Select')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('model.DueDate')">
                    <el-date-picker v-model="form.EndDate"
                                    size="small"
                                    :placeholder="$t('model.Select')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="
                                  $t('model.Assignee')">
                    <el-select @change="changeAssign"
                               size="small"
                               clearable
                               v-model="assign"
                               :placeholder="$t('model.SelectAssignee')">
                      <el-option v-for="item in projectUser"
                                 :key="item.UserId"
                                 :label="item.FullName"
                                 :value="item.UserId">
                        <div class="user-logo">
                          <img :src="item.AvatarUrl"
                               alt="">
                        </div>
                        <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.Watching')">
                    <el-select v-model="form.WatchingUserIds"
                               clearable
                               size="small"
                               multiple
                               :placeholder="$t('model.SelectWatching')">
                      <el-option v-for="item in projectUser"
                                 :key="item.UserId"
                                 :label="item.FullName"
                                 :value="item.UserId">
                        <div class="user-logo">
                          <img :src="item.AvatarUrl"
                               alt="">
                        </div>
                        <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.Location')">
                    <div v-if="this.plan.PlanType === 0">
                      <div v-if="addTaskPointList && addTaskPointList.length>0 && addTaskPointList[0].room">
                        <el-tag v-for="i in addTaskPointList"
                                :key="i.room.id">{{i.room.name}}</el-tag>
                      </div>
                    </div>
                    <el-input v-else
                              v-model="locationText"
                              size="small"
                              :placeholder="$t('taskDialog.Location')"></el-input>
                  </el-form-item>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label-width="0">
                        <el-upload ref="upload"
                                   action=""
                                   :multiple="true"
                                   :limit="limit"
                                   :accept="picAccept"
                                   style="width:100%"
                                   :auto-upload="false"
                                   :show-file-list="false"
                                   :file-list="allFileList"
                                   :on-change="handlePicChange"
                                   :on-success="handlePicSuccess"
                                   :on-exceed="masterFileMax"
                                   :http-request="postUpPic">
                          <el-button slot="trigger"
                                     size="small"
                                     style="width:100%"
                                     type="primary">{{$t('taskDialog.AddPhoto')}}</el-button>
                        </el-upload>
                        <div class="pic-box"
                             :style="{height:picList.length>=4? height +'px':height}"
                             v-if="picList.length>0">
                          <myScroll style="width:94%;height:100%;margin:0 auto">
                            <el-table :data="picList"
                                      :show-header="false">
                              <el-table-column width="55">
                                <i class="el-icon-document"></i>
                              </el-table-column>
                              <el-table-column>
                                <template slot-scope="scope">
                                  {{scope.row.name}}
                                </template>
                              </el-table-column>
                              <el-table-column width="55">
                                <template slot-scope="scope">
                                  <el-button size="small"
                                             circle
                                             @click="removePic(scope.$index)"
                                             type="danger">
                                    <i class="el-icon-delete"></i>
                                  </el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </myScroll>
                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item :label="$t('model.Description')">
                    <el-input size="small"
                              v-model="form.Description"
                              type="textarea"
                              :placeholder="$t('model.DescribeTheTask')"></el-input>
                  </el-form-item>
                </template>

                <template class="batch-task"
                          v-if="addTaskPointList.length>1 && forAll">
                  <el-form-item :label="$t('model.Type')">
                    <el-select size="small"
                               :disabled="true"
                               v-model="type">
                      <el-option v-for=" i of taskType"
                                 :key="i.Key"
                                 :label="i.Value"
                                 :value="i.Key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.Status')">
                    <el-select size="small"
                               v-model="form.Status">
                      <el-option v-for=" i of taskStatus"
                                 :key="i.Value"
                                 :label="$t('api.'+i.Key)"
                                 :value="i.Value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.TaskGroup')">
                    <el-select size="small"
                               style="width:85%"
                               clearable
                               v-model="form.TaskPhaseId">
                      <el-option v-for="i of taskGroup"
                                 :key="i.PhaseId"
                                 :label="i.Name"
                                 :value="i.PhaseId"></el-option>
                    </el-select>
                    <el-button circle
                               type="primary"
                               size="small"
                               v-has="'Create Task Group'"
                               :title="$t('groupDialog.AddTaskGroup')"
                               style="position: absolute;top:50%;transform: translateY(-50%);right:0"
                               @click="openGroupDialog"><i class="el-icon-plus"></i></el-button>
                  </el-form-item>
                  <el-form-item :label="$t('model.StartDate')">
                    <el-date-picker v-model="form.StartDate"
                                    size="small"
                                    :placeholder="$t('model.Select')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('model.DueDate')">
                    <el-date-picker v-model="form.EndDate"
                                    size="small"
                                    :placeholder="$t('model.Select')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('model.Assignee')">
                    <el-select @change="changeAssign"
                               size="small"
                               clearable
                               v-model="assign"
                               :placeholder="$t('model.SelectAssignee')">
                      <el-option v-for="item in projectUser"
                                 :key="item.UserId"
                                 :label="item.FullName"
                                 :value="item.UserId">
                        <div class="user-logo">
                          <img :src="item.AvatarUrl"
                               alt="">
                        </div>
                        <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.Watching')">
                    <el-select v-model="form.WatchingUserIds"
                               clearable
                               size="small"
                               multiple
                               :placeholder="$t('model.SelectWatching')">
                      <el-option v-for="item in projectUser"
                                 :key="item.UserId"
                                 :label="item.FullName"
                                 :value="item.UserId">
                        <div class="user-logo">
                          <img :src="item.AvatarUrl"
                               alt="">
                        </div>
                        <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>

                <el-form-item :label="$t('model.CreateTaskForEveryRoom')"
                              label-width="200px"
                              v-if="showAll &&type !== 1">
                  <div style="margin-top:5px">
                    <el-switch v-model="forAll">
                    </el-switch>
                    <span v-if="forAll"> {{addTaskPointList.length}} {{$t('model.tasks are going to be created')}}</span>
                  </div>
                </el-form-item>
              </div>
              <div v-else>
                <!-- Task Template -->
                <el-form-item :label="$t('model.TaskTemplate')"
                              key="3"
                              :rules="rules.TaskTemplateId"
                              prop="TaskTemplateId">
                  <el-select size="small"
                             @change='templateChange'
                             v-model="form.TaskTemplateId">
                    <el-option v-for=" i of taskTemplates"
                               :key="i.Id"
                               :label="`${i.Name} (${i.Items.length} tasks)`"
                               :value="i.Id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.Status')">
                  <el-select size="small"
                             v-model="form.Status">
                    <el-option v-for=" i of taskStatus"
                               :key="i.Value"
                               :label="$t('api.'+i.Key)"
                               :value="i.Value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.TaskGroup')">
                  <el-select size="small"
                             style="width:85%"
                             clearable
                             v-model="form.TaskPhaseId">
                    <el-option v-for="i of computedTaskGroups"
                               :key="i.PhaseId"
                               :label="i.Name"
                               :value="i.PhaseId"></el-option>
                  </el-select>
                  <el-button circle
                             type="primary"
                             size="small"
                             v-has="'Create Task Group'"
                             :title="$t('groupDialog.AddTaskGroup')"
                             style="position: absolute;top:50%;transform: translateY(-50%);right:0"
                             @click="openGroupDialog"><i class="el-icon-plus"></i></el-button>
                </el-form-item>
                <el-form-item :label="$t('model.StartDate')">
                  <el-date-picker v-model="form.StartDate"
                                  size="small"
                                  :placeholder="$t('model.Select')">
                  </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('model.DueDate')">
                  <el-date-picker v-model="form.EndDate"
                                  size="small"
                                  :placeholder="$t('model.Select')">
                  </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('model.Assignee')">
                  <el-select @change="changeAssign"
                             size="small"
                             clearable
                             v-model="assign"
                             :placeholder="$t('model.SelectAssignee')">
                    <el-option v-for="item in projectUser"
                               :key="item.UserId"
                               :label="item.FullName"
                               :value="item.UserId">
                      <div class="user-logo">
                        <img :src="item.AvatarUrl"
                             alt="">
                      </div>
                      <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.Watching')">
                  <el-select v-model="form.WatchingUserIds"
                             clearable
                             size="small"
                             multiple
                             :placeholder="$t('model.SelectWatching')">
                    <el-option v-for="item in projectUser"
                               :key="item.UserId"
                               :label="item.FullName"
                               :value="item.UserId">
                      <div class="user-logo">
                        <img :src="item.AvatarUrl"
                             alt="">
                      </div>
                      <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </myScroll>
        </el-form>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="close()">{{$t('model.Cancel')}}</el-button>
        <el-button type="primary"
                   size="small"
                   @click="save"
                   :loading="btnLoading">{{$t('model.Save')}}</el-button>
      </div>
    </el-dialog>
    <Group-Dialog :showDialog="groupDialog.showDialog"
                  :jobsiteId="form.JobsiteId"
                  @closeDialog="closeGroupDialog"></Group-Dialog>

    <Product-Dialog :showDialog="nonM2ProductDialog.showDialog"
                    @closeDialog="closeNonM2ProductDialog"></Product-Dialog>
  </div>
</template>

<script>
import {
  addTask, addTaskGroup, getProductList, sumTaskTotalQty, getProductById, getTaskCount
} from '@/api/config'

import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import GroupDialog from '@components/group/groupDialog'
import { Upload } from '@/api/request'
import ProductDialog from '@/components/product/productDialog.vue'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data () {
    const checkNonM2ProductId = (rule, value, callback) => {
      if (value !== this.form.nonM2ProductId) {
        value = this.form.nonM2ProductId
      }
      if (!value) {
        return callback(new Error(this.$t('model.PleaseSelectOneProduct')))
      } else {
        callback()
      }
    }
    const checkTaskTotalQty = (rule, value, callback) => {
      if (value !== this.form.taskTotalQty) {
        value = this.form.taskTotalQty
      }
      if (!value || parseFloat(value) <= 0) {
        return callback(new Error(this.$t('productDialog.QuantityMustGreaterThan0')))
      }
      if (parseFloat(value) > this.nonM2Product.RetainageQty) {
        return callback(new Error(this.$t('model.TaskTotalQtyCannotGreaterThanJobsiteRetaingeQty')))
      } else {
        callback()
      }
    }
    return {
      btnLoading: false,
      forAll: true,
      locationText: '',
      form: {
        TaskPhaseId: '',
        Status: 'Open',
        MaxRh: 85,
        StartDate: new Date(),
        TaskTemplateId: '',
        taskTotalQty: 0,
        nonM2ProductId: ''
      },
      addGroupByTemplate: null,
      Name: '',
      assign: '',
      groupDialog: {
        showDialog: false
      },
      allFileList: [],
      picList: [],
      picAccept: '.jpg,.jpeg,.png,.gif,.bmp',
      limit: 9,
      height: 0,
      subtype: 0,
      nonM2Product: {
        SKU: null,
        Quantity: 0,
        Unit: null,
        RetainageQty: 0
      },
      nonM2ProductList: [],
      nonM2ProductCondition: {
        SKU: null,
        JobsiteId: null,
        PageIndex: 1,
        PageSize: 10,
        GetRecycle: false,
        OrderBy: 'LastUpdatedOn desc',
        ShowTaskTotalQty: true
      },
      nonM2ProductDialog: {
        showDialog: false
      },
      rules:
      {
        TaskTemplateId: [
          {
            required: true, message: this.$t('model.PleaseSelectOneTemplate'), trigger: 'change'
          }
        ],
        taskTotalQty: [{
          validator: checkTaskTotalQty, trigger: 'blur'
        }],
        nonM2ProductId: [{
          validator: checkNonM2ProductId, trigger: 'change'
        }]
      },
      taskCount: 0
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'taskStatus', 'taskType', 'taskWorkType', 'taskGroup', 'plan', 'projectUser', 'taskTemplates']),
    showAll () {
      if (this.$store.state.diag.data.addTaskPointList.length > 1) {
        return true
      } else {
        return false
      }
    },
    computedTaskGroups () {
      let groups = this.taskGroup.slice()
      if (this.addGroupByTemplate) {
        groups.push({
          PhaseId: this.addGroupByTemplate.PhaseId,
          Name: this.addGroupByTemplate.Name
        })
      }
      return groups
    },
    addTaskPointList () {
      return this.$store.state.diag.data.addTaskPointList
    },
    list () {
      return this.$store.state.diag.data.taskList
    }
  },
  created () {
  },
  mounted () {

  },
  watch: {
    picList (to, from) {
      if (to.length > 5) {
        this.height = 200
      } else {
        this.height = 'auto'
      }
    },
    forAll (to, from) {
      if (!to) {
        if (this.type === 0) {
          let name = ''
          this.addTaskPointList.forEach(res => {
            name += res.room.name + ','
          })
          this.Name = name.substring(0, name.length - 1)
        }
      }
    },
    showDialog (to, from) {
      if (to) {
        this.picList = []
        this.btnLoading = false
        this.locationText = ''
        this.addGroupByTemplate = null
        this.form = {
          TaskPhaseId: '',
          Status: 'Open',
          MaxRh: 85,
          StartDate: new Date(),
          taskTotalQty: 0,
          nonM2ProductId: ''
        }
        if (this.type === 3 && this.taskTemplates.length === 1) {
          this.form.TaskTemplateId = this.taskTemplates[0].Id
          this.templateChange(this.taskTemplates[0].Id)
        }
        if (this.plan.PlanType === 0) {
          if (this.addTaskPointList.length > 0 && this.addTaskPointList[0].room) {
            this.Name = this.addTaskPointList[0].room.name
          } else {
            this.Name = ''
          }
        } else {
          this.subtype = 1
          this.getNonM2ProductList()
        }
        if (!this.Name || this.type === 2) {
          let query = {
            JobsiteId: this.jobsiteID,
            Type: this.type
          }
          getTaskCount(query).then(res => {
            this.taskCount = res
            if (this.type === 0) {
              this.Name = this.$t('model.Task') + '-' + (this.taskCount + 1)
            } else if (this.type === 1) {
              this.Name = this.$t('model.Product') + '-' + (this.taskCount + 1)
            } else if (this.type === 2) {
              this.Name = this.$t('model.Probe') + '-' + (this.taskCount + 1)
            }
          })
        }
        setTimeout(() => {
          this.$refs['formTask'].clearValidate()
        }, 10)
      }
    }
  },
  methods: {
    masterFileMax (files, fileList) {
      this.$message.warning(this.$t('upload.Pleaseuploadamaximumofphotos/videos', [this.limit]))
    },
    handlePicSuccess (file, fileList) {
      this.$refs.upload.clearFiles()
    },
    templateChange (id) {
      let template = this.taskTemplates.find(q => q.Id === id)
      let group = this.taskGroup.find(q => q.Name === template.GroupName)
      if (template.GroupName) {
        if (group) {
          this.form.TaskPhaseId = group.PhaseId
          this.addGroupByTemplate = null
        } else {
          this.addGroupByTemplate = {
            JobsiteId: this.jobsiteID,
            PhaseId: uuid.v4(),
            StartDate: new Date(),
            Name: template.GroupName
          }
          this.form.TaskPhaseId = this.addGroupByTemplate.PhaseId
        }
      } else {
        this.form.TaskPhaseId = null
        this.addGroupByTemplate = null
      }
    },
    nonM2ProductIdChange () {
      this.form.taskTotalQty = 0
      this.$refs['formTask'].clearValidate()
      this.$forceUpdate()
    },
    onInput (value) {
      value = value.replace(/[^0-9.]/g, '')
      value = value.indexOf('.') > -1 ? value.slice(0, value.indexOf('.') + 3) : value
      var dom = document.getElementById('taskTotalQtyInput')
      this.form.taskTotalQty = value
      dom.value = value
      this.$forceUpdate()
    },
    handlePicChange (file, fileList) {
      this.picList.push(file)
    },
    uploadingPic (file, taskId) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('file', file.raw)
        formData.append('taskId', taskId)
        let url = '/api/TaskPhotos'
        Upload(url, formData).then(result => {
          resolve(1)
        })
      })
    },
    async postUpPic (taskId) {
      return new Promise(async (resolve, reject) => {
        if (this.picList.length > 0) {
          let time = 0
          for (let i of this.picList) {
            time += await this.uploadingPic(i, taskId)
          }
          if (time === this.picList.length) {
            resolve()
          }
        } else {
          resolve()
        }
      })
    },
    removePic (index) {
      this.picList.splice(index, 1)
      this.allFileList = this.picList
    },
    addTaskMoisture (array, pointList, taskType, taskName) {
      let shapeArr = []
      if (pointList[0].room) {
        for (let i in pointList) {
          let TaskShapes = {
            ShapeId: pointList[i].room.floor.planRegions[0].id,
            ShapeName: pointList[i].room.name,
            ShapePerimeter: pointList[i].room.floor.region.perimeter,
            ShapeArea: pointList[i].room.floor.region.signedArea,
            RoomShapeId: pointList[i].room.id,
            ShapeType: 0
          }
          shapeArr.push(TaskShapes)
        }
      }
      for (let [index, value] of pointList.entries()) {
        let obj = {}
        obj.TaskId = uuid.v4()
        obj.TaskType = taskType
        obj.JobsiteId = this.jobsiteID
        obj.Name = taskName
        obj.LocationX = value.point.x
        obj.LocationY = value.point.y
        obj.PlanId = this.plan.PlanId
        obj.LayerShapeId = this.plan.LinkLayerShapeId
        obj.LocationType = value.room ? 1 : 0
        obj.LocationShapeId = value.room ? value.room.id : ''
        obj.RoomId = value.room ? value.room.id : ''
        obj.TaskSubtype = this.subtype
        if (value.room) {
          obj.TaskShapes = []
          if (!this.forAll || pointList.length === 1) {
            obj.TaskShapes = shapeArr
            obj.Name = taskName
          } else {
            obj.TaskShapes.push(shapeArr[index])
            if (this.type === 0) {
              obj.Name = value.room.name
            }
            if (this.type === 2) {
              obj.Name = this.$t('model.Probe') + '-' + (this.taskCount + 1 + index)
            }
          }
        }
        for (let i in this.form) {
          obj[i] = this.form[i]
        }
        array.push(obj)
      }
    },
    getTaskShapeId (prod) {
      let owner = prod.owner
      while (owner) {
        if (owner.id) {
          return owner.id
        }
        owner = owner.parentShape
      }
    },
    getRegionPerimeter (owner) {
      if (owner.region) {
        return owner.region.perimeter
      } else if (owner.parentShape.region) {
        return owner.parentShape.region.perimeter
      }
      return 0
    },
    addProductIntsall (array, pointList, taskName) {
      for (let value of pointList) {
        let fatherTaskId = uuid.v4()
        let objList = []
        if (!value.product || value.product.length === 0) {
          continue
        }
        if (value.product && value.product.length > 0) {
          value.product.forEach(res => {
            res.id = res.prod.id
            objList.push(res)
          })
        }
        let taskList = []
        for (let i of objList) {
          if (i.prod && this.$config.IsTrackableProduct(i)) {
            if (!taskList.find(q => q.id === i.prod.id && q.assignType === i.TaskAssignType)) {
              taskList.push({ id: i.prod.id, assignType: i.TaskAssignType })
            }
          }
        }
        let obj = {}
        obj.JobsiteId = this.jobsiteID
        obj.RoomId = value.room.id
        obj.PlanId = this.plan.PlanId
        obj.LocationType = 1
        obj.LayerShapeId = this.plan.LinkLayerShapeId
        if (this.addTaskPointList.length === 1) {
          obj.Name = taskName
        } else {
          obj.Name = value.room.name
        }
        obj.TaskId = fatherTaskId
        obj.LocationX = value.point.x
        obj.LocationY = value.point.y
        obj.TaskType = 4
        obj.LocationShapeId = value.room.id
        let arrShape = []
        for (let i of value.room.floor.planRegions) {
          let TaskShapes = {
            ShapeId: i.id,
            ShapeName: value.room.name,
            ShapePerimeter: value.room.floor.region.perimeter,
            ShapeArea: value.room.floor.region.signedArea,
            RoomShapeId: value.room.id,
            ShapeType: 0
          }
          arrShape.push(TaskShapes)
        }
        obj.TaskShapes = arrShape
        for (let i in this.form) {
          obj[i] = this.form[i]
        }
        array.push(obj)

        taskList.forEach(item => {
          let obj = {}
          const id = uuid.v4()
          obj.TaskId = id
          let TaskProductObj = {
            SKU: item.id,
            ProjectId: this.plan.LinkProjectId,
            Quantity: 0.0,
            TotalQty: 0,
            TaskId: id
          }
          let arrShape = []
          objList.forEach(res => {
            let TaskShapesObj = {}
            if (res.prod &&
              res.prod.id === item.id &&
              res.TaskAssignType === item.assignType) {
              TaskProductObj.TotalQty += res.netArea
              TaskProductObj.Quantity += res.usage
              if (res.locationType) {
                obj.LocationType = res.locationType
              }
              obj.ProductType = res.type
              TaskShapesObj.ShapeId = this.getTaskShapeId(res)
              TaskShapesObj.ShapeName = value.room.name
              TaskShapesObj.RoomShapeId = value.room.id
              TaskShapesObj.ShapeType = 0
              if (res.type === 1) {
                TaskShapesObj.ShapePerimeter = this.getRegionPerimeter(res.owner)
              }
              if (res.type === 2 || res.type === 3) {
                TaskShapesObj.ShapePerimeter = res.netArea
              }
              TaskShapesObj.ShapeArea = res.netArea
              arrShape.push(TaskShapesObj)
            }
          })
          obj.TaskShapes = arrShape
          obj.AssignType = item.assignType
          obj.TaskProduct = TaskProductObj
          obj.JobsiteId = this.jobsiteID
          obj.RoomId = value.room.id
          obj.PlanId = this.plan.PlanId
          obj.LayerShapeId = this.plan.LinkLayerShapeId
          obj.Name = item.id
          obj.LocationX = 0.0
          obj.TaskType = 3
          obj.LocationY = 0.0
          obj.ParentTaskId = fatherTaskId
          for (let i in this.form) {
            obj[i] = this.form[i]
          }
          array.push(obj)
        })
      }
    },
    save () {
      this.$refs['formTask'].validate(async (valid) => {
        if (valid) {
          if (this.subtype === 1 && parseFloat(this.form.taskTotalQty) > this.nonM2Product.RetainageQty) {
            this.$notify({ title: this.$t('api.WARNING'), message: this.$t('model.TaskTotalQtyCannotGreaterThanJobsiteRetaingeQty') })
            return
          }
          this.btnLoading = true
          let array = []
          if (this.type !== 3) {
            if (this.plan.PlanType === 0) {
              if ((this.type === 0 || this.type === 2)) {
                this.addTaskMoisture(array, this.addTaskPointList, this.type, this.Name)
              }
              if (this.type === 1) {
                this.addProductIntsall(array, this.addTaskPointList, this.Name)
              }
            }
            if (this.plan.PlanType === 1 || this.plan.PlanType === 2) {
              for (let value of this.addTaskPointList) {
                let obj = {}
                obj.TaskId = uuid.v4()
                obj.TaskType = this.type
                obj.JobsiteId = this.jobsiteID
                obj.Name = this.Name
                obj.LocationX = value.point.x
                obj.LocationY = value.point.y
                obj.PlanId = this.plan.PlanId
                obj.LayerShapeId = this.plan.LinkLayerShapeId
                obj.RoomId = ''
                obj.LocationShapeId = ''
                obj.TaskSubtype = this.subtype
                if (this.type === 1 && this.subtype === 1) {
                  obj.TaskProduct = {
                    SKU: this.nonM2Product.SKU,
                    ProductId: this.form.nonM2ProductId,
                    TotalQty: this.form.taskTotalQty <= 0 ? 0 : this.form.taskTotalQty
                  }
                }
                this.form.TaskShapes = [{
                  TaskId: obj.TaskId,
                  RoomShapeId: '0',
                  ShapeArea: 0,
                  ShapeId: '0',
                  ShapeName: this.locationText,
                  ShapePerimeter: 0,
                  ShapeType: 0
                }]
                for (let i in this.form) {
                  obj[i] = this.form[i]
                }
                array.push(obj)
              }
            }
          } else {
            // task template
            let template = this.taskTemplates.find(q => q.Id === this.form.TaskTemplateId)
            let addTaskPoint = this.addTaskPointList[0]
            let index = 0
            for (let item of template.Items) {
              let randomPoint = { x: addTaskPoint.point.x, y: addTaskPoint.point.y }
              if (index !== 0) {
                if (addTaskPoint.room) {
                  randomPoint = this.$parent.getRandomPoint(addTaskPoint.room.id)
                } else {
                  if (addTaskPoint.spacing) {
                    switch (addTaskPoint.rotation) {
                      case 0:
                        randomPoint.x = addTaskPoint.point.x + (addTaskPoint.spacing * index)
                        break
                      case 1:
                        randomPoint.y = addTaskPoint.point.y - (addTaskPoint.spacing * index)
                        break
                      case 2:
                        randomPoint.x = addTaskPoint.point.x - (addTaskPoint.spacing * index)
                        break
                      case 3:
                        randomPoint.y = addTaskPoint.point.y + (addTaskPoint.spacing * index)
                    }
                  } else {
                    randomPoint.x = addTaskPoint.point.x + (304.8 * 6 * index)
                  }
                }
              }
              let taskName = item.TaskName
              if (addTaskPoint.room && addTaskPoint.room.name) {
                taskName += ' (' + addTaskPoint.room.name + ')'
              }
              if (item.TaskType === 1) {
                if (addTaskPoint.product && addTaskPoint.product.length > 0) {
                  let pointList = [{
                    point: randomPoint,
                    room: addTaskPoint.room,
                    product: addTaskPoint.product
                  }]
                  this.addProductIntsall(array, pointList, taskName)
                  index++
                }
              } else {
                let pointList = [{
                  point: randomPoint,
                  room: addTaskPoint.room,
                  product: addTaskPoint.product
                }]
                this.addTaskMoisture(array, pointList, item.TaskType, taskName)
                index++
              }
            }
          }
          let params = []
          if (this.addTaskPointList.length > 1 && !this.forAll) {
            params.push(array[0])
          } else {
            params = array
          }
          if (this.addGroupByTemplate) {
            let params = [this.addGroupByTemplate]
            await addTaskGroup(params)
          }
          addTask(params).then(async res => {
            let taskIdList = []
            res.forEach(res => {
              if (!res.ParentTaskId) {
                taskIdList.push(res)
              }
            })
            if (taskIdList.length > 0) {
              if (params[0].TaskType === 0 || params[0].TaskType === 2) {
                await this.postUpPic(params[0].TaskId)
                this.btnLoading = false
                this.close(taskIdList)
              } else {
                for (let i of params) {
                  if (!i.ParentTaskId) {
                    await this.postUpPic(i.TaskId)
                    this.btnLoading = false
                  }
                }
                this.btnLoading = false
                this.close(taskIdList)
              }
            } else {
              this.close()
            }
          }).catch(err => {
            this.btnLoading = false
            console.log(err)
          })
        }
      })
    },
    close (task) {
      let that = this
      this.Name = ''
      this.forAll = true
      this.assign = ''
      this.allFileList = []
      if (task) {
        if (task.length === 1) {
          let point = {
            x: task[0].LocationX,
            y: task[0].LocationY
          }
          this.$store.commit('diag/setSelectPoint', point)
          this.$emit('closeDialog', task[0].TaskId)
        }
        if (task.length > 1) {
          let taskIdList = []
          task.forEach(res => {
            taskIdList.push(res.TaskId)
          })
          this.$emit('closeDialog', taskIdList)
        }
      } else {
        that.$emit('closeDialog')
      }
      this.form.nonM2ProductId = ''
      this.form.taskTotalQty = 0
      this.$refs['formTask'].resetFields()
      this.$refs['formTask'].clearValidate()
    },
    changeAssign () {
      this.form.AssignedUserIds = []
      if (this.assign.length < 1) {
        this.form.AssignedUserIds = []
      } else {
        this.form.AssignedUserIds.push(this.assign)
      }
    },
    closeGroupDialog (id) {
      if (id) {
        this.$store.dispatch('getTaskGroup').then(() => {
          this.$nextTick(() => {
            this.form.TaskPhaseId = id
          })
        })
      }
      this.groupDialog.showDialog = false
    },
    openGroupDialog () {
      this.groupDialog.showDialog = true
    },
    getNonM2ProductList () {
      let that = this
      that.nonM2ProductCondition.JobsiteId = that.jobsiteID
      getProductList(that.nonM2ProductCondition).then(res => {
        that.nonM2ProductList = res.Data
        this.getNonM2Product()
        this.nonM2ProductIdChange()
      })
    },
    async showNonM2ProductSelect (e) {
      if (!e) {
        this.nonM2ProductCondition.SKU = null
        await this.getNonM2ProductList()
      }
    },
    async remoteMethod (query) {
      if (query !== '') {
        this.nonM2ProductCondition.SKU = query
        await this.getNonM2ProductList()
      }
    },
    getNonM2Product () {
      let that = this
      /*  that.nonM2ProductList.forEach(async ele => {
  if (ele.ProductId === that.form.nonM2ProductId) {
    that.nonM2Product = ele
    if (!ele.TaskTotalQty || ele.TaskTotalQty === 0) {
      that.nonM2Product.RetainageQty = ele.Quantity
    } else {
      that.nonM2Product.RetainageQty = (ele.Quantity - ele.TaskTotalQty).toFixed(2)
    }
  }
}) */
      if (!that.form.nonM2ProductId) {
        return
      }
      let param = that.form.nonM2ProductId + '?showTaskTotalQty=true'
      getProductById(param, true).then(async res => {
        that.nonM2Product = res
        if (!res.TaskTotalQty || res.TaskTotalQty === 0) {
          that.nonM2Product.RetainageQty = res.Quantity
        } else {
          that.nonM2Product.RetainageQty = (res.Quantity - res.TaskTotalQty).toFixed(2)
        }
      })
    },
    openNonM2ProductDialog () {
      this.nonM2ProductDialog.showDialog = true
    },
    closeNonM2ProductDialog (id) {
      let that = this
      if (id) {
        this.getNonM2ProductList()
        that.form.nonM2ProductId = id
      }
      this.nonM2ProductDialog.showDialog = false
    },
    sumTaskTotalQty (pid) {
      let that = this
      let condition = {
        jobsiteId: this.jobsiteID,
        productId: pid
      }
      sumTaskTotalQty(condition, true).then(res => {
        that.nonM2Product.RetainageQty = res
      })
    }
  },
  components: {
    GroupDialog,
    ProductDialog
  }
}
</script>
<style lang="scss">
.form-box {
  .el-upload {
    width: 100%;
  }
}
[type="number"]::-webkit-inner-spin-button {
  display: none;
}
</style>
<style scoped lang="scss">
.form-box {
  max-width: 520px;
  margin: 0 auto;
  overflow: hidden;
  .el-upload {
    width: 100%;
  }
  .pic-box {
    overflow: hidden;
    width: 100%;
  }
}

.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
</style>
